import { Form, Input, message, Button } from "antd";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./style.css";
import { clientAPI } from "../../../utils/api";
import { ClipLoader } from "react-spinners";

const AddClient = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const location = useLocation();
  const clientId = location.state?.clientId;

  // Load client data if editing
  useEffect(() => {
    if (clientId) {
      const loadClient = async () => {
        try {
          setLoading(true);
          const response = await clientAPI.getClientDetail(clientId);
          form.setFieldsValue({
            client: response.data.name,
            phone: response.data.phone,
            email: response.data.email,
            address: response.data.address,
          });
        } catch (error) {
          messageApi.error("Failed to load client details");
        } finally {
          setLoading(false);
        }
      };
      loadClient();
    }
  }, [clientId, form, messageApi]);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const clientData = {
        name: values.client,
        phone: values.phone,
        email: values.email,
        address: values.address,
      };

      if (clientId) {
        await clientAPI.updateClient(clientId, clientData);
        messageApi.success("Client updated successfully!");
      } else {
        await clientAPI.createClient(clientData);
        messageApi.success("Client added successfully!");
      }

      form.resetFields();
      setTimeout(() => {
        navigate("/client-list");
      }, 500);
    } catch (error) {
      messageApi.error(error.message || "Failed to save client!");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return loading ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      className="pdf-loader-overlay"
    >
      <ClipLoader size={60} color="#e2ae03" />
    </div>
  ) : (
    <div className="new-client">
      {contextHolder}
      <div className="form-wrapper">
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <div className="form-heading">Client Information</div>
          <Form.Item
            label="Client Name"
            name="client"
            rules={[{ required: true, message: "Please Add Client Name!" }]}
          >
            <Input placeholder="Client Name" />
          </Form.Item>

          <div className="item-wrapper">
            <div className="item">
              <Form.Item
                label="Phone Number"
                name="phone"
                rules={[
                  { required: true, message: "Please Add Phone Number!" },
                ]}
              >
                <Input placeholder="Phone Number" />
              </Form.Item>
            </div>
            <div className="item">
              <Form.Item
                label={
                  <span>
                    Email Address{" "}
                    <span style={{ color: "#999", fontWeight: 400 }}>
                      (Optional)
                    </span>
                  </span>
                }
                name="email"
                rules={[
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                ]}
              >
                <Input placeholder="Email Address" />
              </Form.Item>
            </div>
          </div>

          <Form.Item
            label="Address"
            name="address"
            rules={[{ required: true, message: "Please Add Address" }]}
          >
            <Input placeholder="Address" />
          </Form.Item>

          <div className="item">
            <Form.Item>
              <button type="submit" disabled={loading} className="submit-btn">
                {loading
                  ? "Saving..."
                  : clientId
                  ? "Update Client"
                  : "Add New Client"}
              </button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AddClient;
